import { Component, Inject, OnInit } from '@angular/core';
import { EImportance } from 'src/app/domain/MGCE/enum/importance';
import { ETypeSubstrat } from 'src/app/domain/MGCE/enum/type-substrat';
import { EZone } from 'src/app/domain/MGCE/enum/zone';
import { Substrat } from 'src/app/domain/MGCE/substrat';
import { ClasseVitesse } from '../../../domain/Shared/classe-vitesse';
import { StringConverter } from '../string-converter';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-mgce-substrat-box',
    templateUrl: './mgce-substrat-box.component.html',
    styleUrls: ['./mgce-substrat-box.component.scss']
})
export class MGCESubstratBoxComponent implements OnInit {
    EZone = EZone;
    public model: Substrat = new Substrat();
    public ZoneList: string[] =
        Object.values(EZone)
            .filter(x => !isNaN(Number(x)))
            .map((x: EZone) => StringConverter.getZoneName(x));

    public ImportanceList: string[] =
        Object.values(EImportance)
            .filter(x => !isNaN(Number(x)))
            .map((x: EImportance) => StringConverter.getImportanceName(x));

    public TypeSubstratList: string[] =
        Object.values(ETypeSubstrat)
            .filter(x => !isNaN(Number(x)))
            .map((x: ETypeSubstrat) => StringConverter.getMGCETypeSubstratName(x));
    
    get CanAdd() {
        return  this.model.Importance && this.model.Zone && this.model.Type;
    }

    constructor(
        public dialogRef: MatDialogRef<MGCESubstratBoxComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Substrat) {
        if (data)
            this.model = Object.assign({}, data);
        else {

        }
    }

    ngOnInit(): void {
    }

    public getClasseVitesseName(c: ClasseVitesse) {
        return StringConverter.getClasseVitesseName(c);
    }

    onCancel(): void {
        this.dialogRef.close(null);
    }

    onConfirm() {
        this.dialogRef.close(this.model);
    }
}
